







































import { Component, Vue, Watch } from "vue-property-decorator";
import { ConfigModule } from "@/store/index";
import { InquiryItem } from "@/api/index";

@Component({})
export default class Inquiry extends Vue {
  /* -------------- data ------------- */
  channel = ""; // 充值渠道
  status = ""; // 充值状态
  id = ""; // 查询id

  isCompletion = false; // 充值是否完成

  orderId = ""; // 订单号
  userId = ""; // 用户id
  serverId = ""; // 服务器id
  itemName = ""; // 商品名
  itemPrice = ""; // 商品价格
  orderStatus = ""; // 订单状态（Fulfill 表示发货完成，其他表示未完成）

  backButtonTitle = ""; // 返回按钮文本

  itemSiteSuccessTitle = ""; // 充值成功标题文本
  itemSiteIncompleteTitle = ""; // 充值未完成标题文本
  itemSiteIncompleteContent = ""; // 充值未完成提示文本

  itemSiteOrderId = ""; // 订单号文本
  itemSiteUserId = ""; // 用户id文本
  itemSiteServerId = ""; // 服务器id文本
  itemSiteItemName = ""; // 商品名文本
  itemSiteItemPrice = ""; // 商品价格文本

  timer?: number; // 定时器id
  timerMaxCount = 50; // 定时器最大轮询50次

  /* -------------- watch ------------- */
  @Watch("lang")
  async onChangeLang (val: string, oldVal: string) {
    if (oldVal) {
      // 获取网站资源
      await ConfigModule.getSiteAssets(val);
    }
  }

  /* -------------- computed ------------- */
  get lang () {
    // 语言key值
    return ConfigModule.lang;
  }

  get gameId () {
    // 商店页面游戏Id
    return ConfigModule.gameId;
  }

  get backLink () {
    // 返回按钮跳转地址
    if (this.gameId) {
      return `/page/shop/${this.gameId}`;
    } else {
      return "/";
    }
  }

  /* -------------- hook ------------- */
  async created () {
    const getSiteAssetsRet = await ConfigModule.getSiteAssets(this.lang);

    this.channel = (this.$route.query.channel as string) || "";
    this.id = (this.$route.query.id as string) || "";
    this.status = (this.$route.query.status as string) || "";

    const siteAssets = getSiteAssetsRet.payload.siteAssets.data.asset;
    this.backButtonTitle = siteAssets.categoryForBackTitle;
    this.itemSiteSuccessTitle = siteAssets.categoryForOrderSuccessTitle;
    this.itemSiteOrderId = siteAssets.categoryForOrderIdTitle;
    this.itemSiteUserId = siteAssets.categoryForOrderUserIdTitle;
    this.itemSiteServerId = siteAssets.categoryForOrderServerIdTitle;
    this.itemSiteItemName = siteAssets.categoryForOrderProductNameTitle;
    this.itemSiteItemPrice = siteAssets.categoryForOrderProductPriceTitle;

    if (this.status === "completion") {
      if (this.channel !== "codapay") {
        this.isCompletion = true;
      }
      // 充值完成，获取订单信息
      this.LoopInquiryItem();
    } else {
      this.itemSiteIncompleteTitle = siteAssets.categoryForOrderPendingTitle;
      this.itemSiteIncompleteContent = siteAssets.categoryForOrderPendingContent;
      // TODO: 处理banktransfer、conveniencestore情景
      // this.itemSiteIncompleteTitle = ??
      // this.itemSiteIncompleteContent = ??
    }
  }

  destroyed () {
    clearTimeout(this.timer);
  }
  /* -------------- methods ------------- */

  /**
   * @description: 轮询查询订单信息
   */
  async LoopInquiryItem () {
    try {
      this.timerMaxCount--;

      const itemInfo: any = await InquiryItem({
        channel: this.channel, // 渠道
        id: this.id, // 查询id
        status: this.status
      });
      console.log("[InquiryItem]", itemInfo);
      this.orderId = itemInfo.payload.orderId;
      this.userId = itemInfo.payload.userId;
      this.serverId = itemInfo.payload.serverId;
      this.itemName = itemInfo.payload.itemName;
      this.itemPrice = itemInfo.payload.itemPrice;
      this.orderStatus = itemInfo.payload.orderStatus;

      if (this.channel === "codapay" && this.orderStatus === "Fulfill") {
        this.isCompletion = true;
      } else if (this.channel === "codapay" && this.orderStatus === "Approved") {
        // 订单取消， back
        this.$router.push(this.backLink);
      } else if (this.orderStatus !== "Fulfill" && this.timerMaxCount > 0) {
        this.timer = setTimeout(this.LoopInquiryItem, 1000);
      }
    } catch (error) {
      console.log(error);
    }
  }
}
